<p *ngIf="content" class="d-flex flex-wrap gapx-2 text-break">
  <span class="mb-0" *ngIf="title">{{ title | translate }}</span>
  <a [href]="getHandle()" role="link" tabindex="0">{{getHandle()}}</a>
</p>
